import { Component, OnInit, Inject,EventEmitter,Output } from '@angular/core';
import { MatDialogRef,MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material';
import { ConfirmboxComponent } from '../confirmbox/confirmbox.component';

@Component({
  selector: 'app-rankings-import',
  templateUrl: './rankings-import.component.html',
  styleUrls: ['./rankings-import.component.scss']
})
export class RankingsImportComponent implements OnInit {
  @Output() OnMakeDefault = new EventEmitter<any>();
  @Output() OnUnsetDefaultRanking = new EventEmitter<any>();
  @Output() removeranking = new EventEmitter<any>();
  confirmDialogRef: MatDialogRef<ConfirmboxComponent>;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<RankingsImportComponent>,
    public dialog: MatDialog
    ) {}

  ngOnInit() {}

  sendSet(set){
    this.dialogRef.close({set});
  }

  setAsDefault(set){
    this.data.sets =this.data.sets.map((e)=>{e.is_default=set.id==e.id?1:0;return e});
     this.OnMakeDefault.emit(set.id);
    } 
  unSetDefaultRanking(set){
    this.data.sets =this.data.sets.map((e)=>{e.is_default=0;return e});
    this.OnUnsetDefaultRanking.emit(set.id);
  }
  removeRanking(set){
    this.confirmDialogRef = this.dialog.open(ConfirmboxComponent, {
      width: '500px',
      data: { 'title': 'Information', 'body': 'Are you sure you want to delete record?'}
    });
      
    this.confirmDialogRef.afterClosed()
    .subscribe(res => {
       if (res) {
        let remaining = this.data.sets.filter((e)=>{
          if(e.id!=set.id)
          return e;
        });
        this.data.sets =remaining;
        this.removeranking.emit(set);
       }
    });
    
  }
   successMessage(msg){
    this.data.successMessage=msg;
   }
}
